import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
 apiKey: "AIzaSyDArHK6Vuhn7B8ElxmisQhogK_XD2-4CU8",
  authDomain: "praveen-kumar-b.firebaseapp.com",
  projectId: "praveen-kumar-b",
  storageBucket: "praveen-kumar-b.firebasestorage.app",
  messagingSenderId: "105778217801",
  appId: "1:105778217801:web:b525b23355a4281596d098"

};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);